import { useState } from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";

export default function TextParaphrase() {
    const [results, setResult] = useState("");
    const [loading, setLoading] = useState(false);

    const controller = async () => {
        const text = document.getElementById("text").value;
        if (!text.trim()) {
            alert("Please enter some text to summarize.");
            return;
        }

        setLoading(true);
        try {
            const response = await fetch("https://ai-feats.nugenesisou.com/paraphrase", {
                method: "POST",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ text })
            });

            if (!response.ok) {
                throw new Error("Failed to summarize the text.");
            }

            const data = await response.json();
            setResult(data.paraphrased_text || "No results generated.");
        } catch (error) {
            console.error("Error summarizing text:", error);
            setResult("Error summarizing text. Please try again later.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Header />
            <main>
                <section class="pad breadcrumbs top-cover">
                    <div id="breadcrumb" class="content">
                        <a href="Home">Home</a><i></i>
                        <span>Text Paraphrase</span>
                    </div>
                </section>

                <section class="security-hero">
                    <div class="content">
                        <div class="pad texts">
                            <h1><b>Free </b> AI Text Paraphrasing</h1>
                            <div class="subtitle">By NuGenesis</div>
                            <div class="text">Your words matter, and our paraphrasing tool helps you find the right ones. With unlimited Custom modes and 9 predefined modes, Paraphraser lets you rephrase text countless ways. Whether you’re writing for work or for class, our product will improve your fluency and enhance the vocabulary, tone, and style of your writing. Simply enter your text into the input box, and our AI will work with you to create the best paraphrase.</div>
                            {/* <div class="text">Enter or paste your text and press "Summarize."</div> */}
                        </div>
                    </div>
                </section>

                <section class="pad">
                    <div class="content">
                        <div class="text-par-container">
                            <p>To rewrite text, enter or paste it here and press "Paraphrase."</p>
                            <div class="buttons">
                                <button>👋 Try Sample Text</button>
                                <button>📋 Paste Text</button>
                            </div>
                            <textarea class="not-focus" placeholder="Enter text here..." id="text"></textarea>
                            <div class="result">{results}</div>
                            <div class="upload">
                                <label for="fileUpload">📂 Upload Doc</label>
                                {/* <input type="file" id="fileUpload" style="display: none;"/> */}
                            </div>
                            <button class="submit-btn"  onClick={controller}>
                                {loading ? "Loading..." : "Paraphrase"}
                            </button>
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
        </>
    );
}
